export const aleksanderJachowski = {
    'meta': {
        'title': 'Psycholog, psychoterapeuta Aleksander Jachowski • COLLIGO',
        'description': 'Psycholog, Psychoterapeuta Systemowy. Pracuje z dorosłymi, rodzinami, dziećmi (od 15 rż). Pomagam osobą doświadczającym: kryzysu, depresji, zaburzeń nastroju.'
    },
    'url': {
        'address': '/torun/zespol/psycholog-psychoterapeuta-systemowy-aleksander-jachowski/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/aleksander-jachowski.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog, psychoterapeuta systemowy, Aleksander Jachowski'
        }
    }
}